export const ORDR_FORMS: any[] = [
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "partyId", "contactMechTypeId", "contactMechId", "contactMechPurposeTypeId", "attName", "address1", "address2", "city", "stateProvinceGeoId", "postalCode", "countryGeoId", "fromDate", "thruDate", "removeLink", "updateLink" ]
        } ],
        "columns" : [ {
            "name" : "postalAddress",
            "title" : "Postal Address"
        }/* , {
            "name" : "contactMechPurposeTypeId",
            "title" : "contactMechPurposeTypeId"
        }, {
            "name" : "attName",
            "title" : "attnName"
        }, {
            "name" : "address1",
            "title" : "address1"
        }, {
            "name" : "address2",
            "title" : "address2"
        }, {
            "name" : "city",
            "title" : "city"
        }, {
            "name" : "stateProvinceGeoId",
            "title" : "stateProvinceGeoId"
        }, {
            "name" : "postalCode",
            "title" : "postalCode"
        }, {
            "name" : "countryGeoId",
            "title" : "countryGeoId"
        }, {
            "name" : "fromDate",
            "title" : "fromDate"
        }, {
            "name" : "thruDate",
            "title" : ""
        }, {
            "name" : "removeLink",
            "title" : ""
        }, {
            "name" : "updateLink",
            "title" : ""
        }  */],
        "formName" : "OrderPostalAddressMaps",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/OrderViewForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "partyId",
            "action" : "",
            "id" : "OrderPostalAddressMaps_partyId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "contactMechTypeId",
            "action" : "",
            "id" : "OrderPostalAddressMaps_contactMechTypeId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "contactMechId",
            "action" : "",
            "id" : "OrderPostalAddressMaps_contactMechId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderId",
            "description" : "WSCO10731",
            "style" : "",
            "id" : "OrderContactInfo_orderId",
            "title" : "Order ID",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            name:"postalAddress",
            title:"Postal Address",
            type:"COMPOSITE",
            innerFields:[
                {
                    "name" : "contactMechPurposeTypeId",
                    "title" : "Contact Purpose"                    
                },
                {
                    "name" : "attName",
                    "title" : "Attention"                    
                },
                {
                    "name" : "address1",
                    "title" : "Address 1"                    
                },
                {
                    "name" : "address2",
                    "title" : "Address 2"                    
                },
                {
                    "name" : "city",
                    "title" : "City"                    
                },
                {
                    "name" : "stateProvinceGeoId",
                    "title" : "Province/State"                    
                },
                {
                    "name" : "countryGeoId",
                    "title" : "Country"                    
                },
                {
                    "name" : "fromDate",
                    "title" : "From Date"                    
                },
                {
                    "name" : "thruDate",
                    "title" : "Thru Date"                    
                },
            ]
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "contactMechPurposeTypeId",
            "description" : "",
            "style" : "",
            "id" : "OrderPostalAddressMaps_contactMechPurposeTypeId",
            "title" : "contactMechPurposeTypeId",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "attName",
            "description" : "",
            "style" : "",
            "id" : "OrderPostalAddressMaps_attName",
            "title" : "attnName",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "address1",
            "description" : "",
            "style" : "",
            "id" : "OrderPostalAddressMaps_address1",
            "title" : "address1",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "address2",
            "description" : "",
            "style" : "",
            "id" : "OrderPostalAddressMaps_address2",
            "title" : "address2",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "city",
            "description" : "",
            "style" : "",
            "id" : "OrderPostalAddressMaps_city",
            "title" : "city",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "stateProvinceGeoId",
            "description" : "",
            "style" : "",
            "id" : "OrderPostalAddressMaps_stateProvinceGeoId",
            "title" : "stateProvinceGeoId",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "postalCode",
            "description" : "",
            "style" : "",
            "id" : "OrderPostalAddressMaps_postalCode",
            "title" : "postalCode",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "countryGeoId",
            "description" : "",
            "style" : "",
            "id" : "OrderPostalAddressMaps_countryGeoId",
            "title" : "countryGeoId",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "OrderPostalAddressMaps_fromDate",
            "title" : "fromDate",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "thruDate",
            "description" : "",
            "id" : "OrderPostalAddressMaps_thruDate",
            "type" : "DISPLAY",
            "title" : "",
            "imageLocation" : ""
        }, {
            "image" : "",
            "width" : "",
            "name" : "removeLink",
            "alternate" : "",
            "description" : "",
            "parameterList" : [ {
            "name" : "partyId"
            }, {
            "name" : "contactMechId"
            } ],
            "id" : "OrderPostalAddressMaps_removeLink",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "target" : "deleteContactMech"
        }, {
            "image" : "",
            "width" : "",
            "name" : "updateLink",
            "alternate" : "",
            "description" : "",
            "parameterList" : [ {
            "name" : "partyId"
            }, {
            "name" : "contactMechId"
            } ],
            "id" : "OrderPostalAddressMaps_updateLink",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "target" : "editcontactmech"
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "contactMechId", "infoString", "contactMechTypeId", "contactMechPurposeTypeId" ]
        } ],
        "columns" : [ {
            "name" : "orderId",
            "title" : "Order ID"
        }, {
            "name" : "infoString",
            "title" : "Email Address"
        }, {
            "name" : "contactMechTypeId",
            "title" : "Contact Mech Type"
        }, {
            "name" : "contactMechPurposeTypeId",
            "title" : "ContactMech PurposeType"
        } ],
        "formName" : "OrderEmailAddressMaps",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/OrderViewForms.xml",
        "type" : "list",
        "fields" : [ {
            "name":"emailAddress" ,
            "title": "Email"  ,
            "type":"COMPOSITE",
            innerFields:[
                {
                    name:"infoString",
                    "title":"Email Address"
                },
                {
                    "name" : "contactMechPurposeTypeId",
                    "title" : "ContactMech PurposeType",
                }
            ]         
        },{
            "conditionGroup" : "",
            "name" : "contactMechId",
            "action" : "",
            "id" : "OrderEmailAddressMaps_contactMechId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderId",
            "description" : "WSCO10731",
            "style" : "",
            "id" : "OrderContactInfo_orderId",
            "title" : "Order ID",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "infoString",
            "description" : "",
            "style" : "",
            "id" : "OrderEmailAddressMaps_infoString",
            "title" : "Email Address",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "contactMechTypeId",
            "description" : "",
            "style" : "",
            "id" : "OrderEmailAddressMaps_contactMechTypeId",
            "title" : "Contact Mech Type",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "contactMechPurposeTypeId",
            "description" : "",
            "style" : "",
            "id" : "OrderEmailAddressMaps_contactMechPurposeTypeId",
            "title" : "ContactMech PurposeType",
            "type" : "HIDDEN",
            "imageLocation" : ""
        } ],
        "target" : ""

    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "partyId", "contactMechTypeId", "contactMechId", "contactMechPurposeTypeId", "areaCode", "countryCode", "contactNumber", "fromDate", "thruDate", "removeLink", "updateLink" ]
        } ],
        "columns" : [ {
            "name" : "orderId",
            "title" : "Order ID"
        }, {
            "name" : "contactMechPurposeTypeId",
            "title" : "contactMechPurposeTypeId"
        }, {
            "name" : "areaCode",
            "title" : "areaCode"
        }, {
            "name" : "countryCode",
            "title" : "countryCode"
        }, {
            "name" : "contactNumber",
            "title" : "contactNumber"
        }, {
            "name" : "fromDate",
            "title" : "fromDate"
        }, {
            "name" : "thruDate",
            "title" : "thruDate"
        }, {
            "name" : "removeLink",
            "title" : ""
        }, {
            "name" : "updateLink",
            "title" : ""
        } ],
        "formName" : "OrderTelecomNumberMaps",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/OrderViewForms.xml",
        "type" : "list",
        "fields" : [ {
            name:"phoneNumber",
            title:"Phone Number",
            type:"COMPOSITE",
            innerFields:[ 
            {
                "name" : "areaCode",
                "title" : "Area Code"
            }, {
                "name" : "countryCode",
                "title" : "Country Code"
            }, {
                "name" : "contactNumber",
                "title" : "Contact Number"
            }, 
            {
                "name" : "contactMechPurposeTypeId",
                "title" : "Purpose"
            }, 
            {
                "name" : "fromDate",
                "title" : "From Date"
            }, {
                "name" : "thruDate",
                "title" : "Thru Date"
            }
         ]
        }, {
            "conditionGroup" : "",
            "name" : "partyId",
            "action" : "",
            "id" : "OrderTelecomNumberMaps_partyId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "contactMechTypeId",
            "action" : "",
            "id" : "OrderTelecomNumberMaps_contactMechTypeId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "contactMechId",
            "action" : "",
            "id" : "OrderTelecomNumberMaps_contactMechId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderId",
            "description" : "WSCO10731",
            "style" : "",
            "id" : "OrderContactInfo_orderId",
            "title" : "Order ID",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "contactMechPurposeTypeId",
            "description" : "",
            "style" : "",
            "id" : "OrderTelecomNumberMaps_contactMechPurposeTypeId",
            "title" : "contactMechPurposeTypeId",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "areaCode",
            "description" : "",
            "style" : "",
            "id" : "OrderTelecomNumberMaps_areaCode",
            "title" : "areaCode",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "countryCode",
            "description" : "",
            "style" : "",
            "id" : "OrderTelecomNumberMaps_countryCode",
            "title" : "countryCode",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "contactNumber",
            "description" : "",
            "style" : "",
            "id" : "OrderTelecomNumberMaps_contactNumber",
            "title" : "contactNumber",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "OrderTelecomNumberMaps_fromDate",
            "title" : "fromDate",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "thruDate",
            "description" : "",
            "style" : "",
            "id" : "OrderTelecomNumberMaps_thruDate",
            "title" : "thruDate",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "image" : "",
            "width" : "",
            "name" : "removeLink",
            "alternate" : "",
            "description" : "",
            "parameterList" : [ {
            "name" : "partyId"
            }, {
            "name" : "contactMechId"
            } ],
            "id" : "OrderTelecomNumberMaps_removeLink",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "target" : "deleteContactMech"
        }, {
            "image" : "",
            "width" : "",
            "name" : "updateLink",
            "alternate" : "",
            "description" : "",
            "parameterList" : [ {
            "name" : "partyId"
            }, {
            "name" : "contactMechId"
            } ],
            "id" : "OrderTelecomNumberMaps_updateLink",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "target" : "editcontactmech"
        } ],
        "target" : ""
    }
]
